module.exports = __webpack_public_path__ + "static/media/designagent.81d565ff.png";